// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 594 ? "about" : chunkId) + "-" + {"134":"ab409de60b3a9539574b","594":"47c9c36e9133f5650622"}[chunkId] + ".js";
};